(() => {
  if (window.IngenioCRO) return;

  const script = document.currentScript;
  const destination = 'G-04SMBBPBXK';
  const records = [];
  const counts = { audit: 0, queued: 0, blocked: 0, ignored: 0 };
  const token = (value) => typeof value === 'string' && /^[a-zA-Z][a-zA-Z0-9 _-]{0,79}$/.test(value) ? value : undefined;
  const identifier = (value) => /^\d{1,20}$/.test(String(value)) ? String(value) : undefined;
  const numeric = (value) => (typeof value === 'number' || (typeof value === 'string' && /^\d+(?:\.\d+)?$/.test(value))) && Number.isFinite(Number(value));
  const integer = (value) => numeric(value) && Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 10000 ? Number(value) : undefined;
  const money = (value) => numeric(value) && Number(value) >= 0 && Number(value) <= 1000000000 ? Number(value) : undefined;
  const destinationType = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return 'external';
      if (url.origin !== window.location.origin) return 'external';
      const type = url.pathname.split('/').filter(Boolean)[0] || 'home';
      return ['products', 'collections', 'pages', 'blogs', 'cart', 'home'].includes(type) ? type : 'other';
    } catch (_) { return undefined; }
  };
  const aliases = { variant: 'experience_variant', source_section: 'placement', mademap_location: 'placement', mademap_product: 'product_handle', mode: 'display_mode', destination: 'destination_type' };
  const converters = { product_id: identifier, variant_id: identifier, position: integer, count: integer, eligible_count: integer, faq_position: integer, cart_value: money, destination: destinationType };
  const home = ['variant', 'cta', 'destination', 'intent', 'category', 'position', 'product_id', 'source_section', 'pillar', 'city'];
  const destacados = ['landing_version', 'intent', 'selection', 'product_id', 'position', 'count'];
  const mademap = ['mademap_product', 'mademap_location', 'faq_position'];
  const cart = ['family', 'mode', 'cart_value', 'eligible_count', 'trigger', 'product_id', 'product_handle', 'variant_id', 'surface'];
  const schemas = new Map();
  ['search_results_view', 'search_result_click', 'search_submit'].forEach(name => schemas.set(name, ['count', 'position', 'product_id', 'resource_type', 'surface']));
  ['home_hero_click', 'home_intent_click', 'home_category_click', 'home_product_click', 'home_quick_add_click', 'home_story_click', 'home_store_click', 'home_newsletter_attempt', 'home_newsletter_success_view'].forEach((name) => schemas.set(name, home));
  ['destacados_intent_select', 'destacados_load_more', 'destacados_product_click', 'destacados_add_to_cart_click'].forEach((name) => schemas.set(name, destacados));
  ['mademap_version_click', 'mademap_accessory_click', 'mademap_accessory_add_click', 'mademap_faq_open'].forEach((name) => schemas.set(name, mademap));
  ['cart_cross_sell_impression', 'cart_cross_sell_dismiss', 'cart_cross_sell_expand', 'cart_cross_sell_add', 'cart_cross_sell_checkout_click'].forEach((name) => schemas.set(name, cart));

  const mode = () => {
    try {
      const role = window.Shopify?.theme?.role;
      const query = new URLSearchParams(window.location.search);
      return script?.dataset.mode !== 'auto' || role !== 'main' || window.Shopify?.designMode || query.has('preview_theme_id') || query.has('preview_key') || query.has('cro_audit') ? 'audit' : 'live';
    } catch (_) { return 'audit'; }
  };
  const permitted = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch (_) { return false; }
  };
  const result = (status, reason) => {
    counts[status] += 1;
    return reason ? { status, reason } : { status };
  };
  const pageLocation = () => {
    const path = window.location.pathname;
    const safePath = /^\/(?:collections|products|pages|blogs)(?:\/[a-z0-9-]+){1,3}\/?$/.test(path) || ['/', '/cart', '/search'].includes(path) ? path : '/';
    return window.location.origin + safePath;
  };
  const track = (name, parameters = {}) => {
    try {
      const fields = schemas.get(name);
      if (!fields) return result('ignored', 'event_not_allowed');
      if (!permitted()) return result('blocked', 'analytics_not_allowed');
      const payload = { measurement_version: 'cro_2026_10_v1', page_type: token(script?.dataset.pageType) || 'other' };
      fields.forEach((field) => {
        if (!Object.prototype.hasOwnProperty.call(parameters, field)) return;
        const value = (converters[field] || token)(parameters[field]);
        if (value !== undefined) payload[aliases[field] || field] = value;
      });
      if (mode() === 'audit') {
        records.push({ name, parameters: payload });
        if (records.length > 100) records.shift();
        return result('audit');
      }
      const eventParameters = { ...payload, send_to: destination, page_location: pageLocation() };
      if (typeof window.gtag === 'function') window.gtag('event', name, eventParameters);
      else {
        window.dataLayer = window.dataLayer || [];
        (function () { window.dataLayer.push(arguments); })('event', name, eventParameters);
      }
      return result('queued');
    } catch (_) { return result('blocked', 'transport_unavailable'); }
  };
  window.IngenioCRO = Object.freeze({
    version: '1.0.0',
    get mode() { return mode(); },
    track,
    inspect: () => ({ mode: mode(), counts: { ...counts }, events: records.map((record) => ({ name: record.name, parameters: { ...record.parameters } })) })
  });
  try {
    if (!window.Shopify?.customerPrivacy) window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  } catch (_) {}
})();
